import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getProjects: 'projects/getProjects',
      getAllUsers: 'getAllUsers',
      ownBankDetails: 'finances/getOwnBankDetails'
    }),
    expensesStatuses () {
      return this.$store.getters.getExpensesStatuses || []
    },
    expensesCategories () {
      return this.$store.getters.getExpensesCategories || []
    },
    currencies () {
      return this.$store.getters.getCurrencies || []
    },
    bankCards () {
      return this.$store.getters.getBankCards || []
    },
    allUsers () {
      return this.$store.getters.getAllUsers || []
    }
  },
  methods: {
    async fetchFormLists () {
      return Promise.all([
        this.$api.expenses.getExpensesStatuses(),
        this.$api.expenses.getExpensesCategories(),
        this.$api.projects.getProjects(),
        this.$api.finances.getCurrencies(),
        this.$api.finances.getBankCards(),
        this.$api.finances.getBankDetailsAll(),
        this.$api.users.getAllUsers()
      ])
    },
    prepareDataForEditAndCreateRequest (fields) {
      let data = {}
      data['expenses_category_id'] = fields.expenses_category.id
      data['expenses_status_id'] = fields.expenses_status.id
      data['amount'] = fields.amount
      data['currency_id'] = fields.currency.id
      if (fields.bank_card) {
        data['bank_card_id'] = fields.bank_card.id
      }
      if (fields.bank_detail) {
        data['bank_detail_id'] = fields.bank_detail.id
      }
      if (fields.receipt_file) {
        data['receipt_file'] = fields.receipt_file
      }
      // data['invoice_url'] = fields.invoice_url
      data['user_id'] = fields.user.id
      if (fields.related_project) {
        data['related_project_id'] = fields.related_project.id
      }
      data['due_date'] = this._toLocalTime(fields.due_date, 'YYYY-MM-DD')
      if (fields.paid_date) {
        data['paid_date'] = this._toLocalTime(fields.paid_date, 'YYYY-MM-DD')
      }
      data['comment'] = fields.comment

      return data
    }
  }
}
